export const WISHLIST_GET_LOADING = "wishlist/get/loading"

export const WISHLIST_GET_ERROR = "wishlist/get/error"

export const WISHLIST_GET_SUCCESS = "wishlist/get/success"

export const WISHLIST_REMOVE = "wishlist/delete"